import appConfig from "./appConfig";
import firebase from "firebase";
import useSWRImmutable from "swr/immutable";

/**
 * おすすめイベント表示を有効にするかどうか
 * これがオフだと取得されず、表示もされない
 * - 購入完了後、カート追加後に表示している
 * - ホロフェス施策が終わったため、無効にしている
 *
 * @deprecated
 * まだ必要なら src/utility/isFeatureEnabled に置き換える
 */
export const isEnableRecommendedEvents = false;

/**
 * @deprecated
 * まだ必要なら src/utility/isFeatureEnabled に置き換える
 */
export const isGiftLetterBannerEnabled = () => {
  const params = new URLSearchParams(window.location.search);
  const showAtJST = new Date("2025-07-25T19:00:00+09:00").getTime();
  return Date.now() >= showAtJST || params.get("giftLetter") === "1";
};

// ギフトレターを有効にするイベントID
export const GIFT_LETTER_EVENT_ID = "evt_s7X9CkAylqheiZH1345L";

/**
 * ギフトレター対象の商品ID
 * 販売終了日時(2025/08/09)を過ぎたあと、該当コードを削除する
 */
export const GIFT_LETTER_GOODS_IDS = new Set([
  "Gevt_s7X9CkAylqhe_0010001C04",
  "Gevt_s7X9CkAylqhe_0010101C04",
  "Gevt_s7X9CkAylqhe_0010201C04",
  "Gevt_s7X9CkAylqhe_0010301C04",
  "Gevt_s7X9CkAylqhe_0010401C04",
  "Gevt_s7X9CkAylqhe_0010501C04",
  "Gevt_s7X9CkAylqhe_0020001C04",
  "Gevt_s7X9CkAylqhe_0020101C04",
  "Gevt_s7X9CkAylqhe_0020201C04",
  "Gevt_s7X9CkAylqhe_0020301C04",
  "Gevt_s7X9CkAylqhe_0030001C04",
  "Gevt_s7X9CkAylqhe_0030101C04",
  "Gevt_s7X9CkAylqhe_0030201C04",
  "Gevt_s7X9CkAylqhe_0030301C04",
]);

/**
 * FANY IDサインインおよび連携機能を有効にするかどうか
 * 本番以外の環境かつlocalStorageにenableFanyIdSignInAndLink: trueが設定されている場合のみ有効
 *
 * @deprecated
 * まだ必要なら src/utility/isFeatureEnabled に置き換える
 */
export const isEnableFanyIdSignInAndLink = () => {
  if (typeof window !== "undefined" && window.localStorage) {
    const localStorageFlag = localStorage.getItem("enableFanyIdSignInAndLink");
    if (localStorageFlag !== null) {
      return !appConfig.isProd && localStorageFlag === "true";
    }
  }
  return false;
};

export type FeatureFlag = {
  globalEnabled: boolean;
  events: {
    [eventId: string]: boolean;
  };
};

/**
 * @deprecated
 * まだ必要なら src/utility/isFeatureEnabled に置き換える
 */
export const getFeatureFlag = async (
  key: string
): Promise<FeatureFlag | undefined> => {
  const snapshot = await firebase
    .firestore()
    .collection("featureFlags")
    .doc(key)
    .get();
  const data = snapshot.data();
  return data as FeatureFlag | undefined;
};

/**
 * @deprecated
 * まだ必要なら src/utility/isFeatureEnabled に置き換える
 */
export const useFreePurchaseEnabled = (
  eventId: string | undefined
): boolean | undefined => {
  const { data } = useSWRImmutable("getFreePurchaseFeatureFlag", async () => {
    return await getFeatureFlag("freePurchase");
  });

  if (data === undefined) {
    return undefined;
  }

  if (data.globalEnabled) {
    return true;
  }

  if (eventId && data.events[eventId]) {
    return true;
  }

  return false;
};
